import { usePatchOrganizationSummary, usePostOrganizationSummary } from '@/api/rest/resources/organization';
import { OrganizationSummary } from '@/api/rest/resources/types/organization';

export const useCreateOrganizationSummary = () => {
  const mutation = usePostOrganizationSummary();
  return useOrganizationSummaryMutation(mutation);
};

export const useUpdateOrganizationSummary = () => {
  const mutation = usePatchOrganizationSummary();
  return useOrganizationSummaryMutation(mutation);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useOrganizationSummaryMutation = (mutation: any) => {
  const submit = async (organizationId: string, summary: Partial<OrganizationSummary>, onSuccess?: () => void) => {
    const response = await mutation.mutateAsync({
      pathVariables: { organization_id: organizationId },
      bodyData: summary,
    });

    onSuccess?.();

    return response;
  };

  const isSubmitting = mutation.isPending;

  return { submit, isSubmitting };
};
